var CentraRequest = require('./model/CentraRequest.js');

module.exports = function (url, method) {
  return new CentraRequest(url, method);
};